import React, { FC } from "react";
import Box from "@mui/material/Box";
import { iDetailListItemProps } from "../../../types/contentType";

import "./detailListItem.scss";

const DetailListItem: FC<iDetailListItemProps> = ({
	title,
	icon,
	value,
	flexible,
	onClick,
	detailListItemClass,
	renderValue,
}) => {
	return (
		<>
			<Box
				onClick={onClick}
				component={"div"}
				style={{ cursor: "pointer" }}
				className={`detailListItem ${detailListItemClass}`}
			>
				<Box className="detailListItemHold">
					<span className="title">{title}</span>
					<Box className="textHold">
						{icon && <span className="iconHold">{icon}</span>}
						{renderValue ? renderValue() : <small>{value}</small>}
						{flexible && <span className="chipPill">flexible</span>}
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default DetailListItem;
